<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在提交数据....">
      <a-form class="ant-advanced-search-form">
        <a-row class="searchrow width-style-auto">
          <a-form-item :colon="false" label="药品类型">
            <a-select v-model="search.type">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.types" :key="item.name" :value="item.name">
                {{item.value}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="药品归属">
            <a-select v-model="search.hq">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option value="1">总部</a-select-option>
              <a-select-option value="0">自定义</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="业务状态">
            <a-select v-model="search.status">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.statuses" :key="item.name" :value="item.name">
                {{item.value}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="关键字">
            <a-input v-model="search.keyword" placeholder="请输入药品名称/首拼模糊检索">
              <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
            </a-input>
          </a-form-item>
          <a-form-item><a-button style="margin-left: 8px" @click="goback">返回</a-button></a-form-item>
        </a-row>
      </a-form>
      <a-row class="search"></a-row>
      <a-row>
        <a-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :xxl="11">
          <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
                   :rowSelection="{fixed:true, selectedRowKeys: grid.selections, type:'radio', onChange: onSelectChange}"
                   rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination" :customRow="checkCustomRow" @change="gridChangeAction">
          </a-table>
        </a-col>
        <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :xxl="11">
          <a-table size="middle" :columns="stockGrid.columns" :loading="stockGrid.loading"
                   :dataSource="stockGrid.data" :scroll="{ x: '100%' }">
            <span slot="operate" slot-scope="text, record">
              <a v-if="record.status !='CANCELED'" class="custom-warn-act" @click="()=>breakAction(record.drugId, record)">报损</a>
              <span v-if="record.status =='CANCELED'">-</span>
            </span>
          </a-table>
        </a-col>
        <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
      </a-row>

    </a-spin>
    <a-modal title="药品报损" :visible="modal.visible" width="40%" @cancel="closeModal" @ok="submitAction()">
      <a-spin :spinning="modal.loading" :tip="modal.tip">
        <a-form :form="modal.form" layout="horizontal" style="margin-top: 20px">
          <a-row>
            <a-col span="12">
              <a-form-item label="药品名称" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{modal.drug.name}}
              </a-form-item>
            </a-col>
            <a-col span="12">
              <a-form-item label="规格/剂型" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12}">
                {{modal.drug.spec}}/{{modal.drug.formName}}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <a-form-item label="生产厂家" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12}">
                {{modal.drug.manufacturer}}
              </a-form-item>
            </a-col>
            <a-col span="12">
              <a-form-item label="当前库存" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                {{currDocDrug.currQty}}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col span="12">
              <a-form-item :colon="false" label="出库单位" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }">
                <a-select ref="stockUnit"  v-decorator="['unitIndex', {rules: [{ required: true, message: '报损单位必须填写!' }], initialValue: modal.unitIndex||0}]" placeholder="剂量单位">
                  <a-select-option v-for="(item,index) in modal.units" :key="item.index" :value="item.index">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col span="12">
              <a-form-item :colon="false" label="报损数量" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12}">
                <a-input-number ref="stockQty" :min="0.01" v-decorator="['stockQty', {rules:[{ required: true, message: '报损数量不能为空!' }], initialValue: '1' }]" placeholder="请输入报损数量"/>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
      </a-spin>

    </a-modal>
  </div>
</template>

<script>
  export default {
    name: "Breakage",
    data() {
      return {
        loading: false,
        init: {
          types: [],
          organs:[],
          statuses: statuses
        },
        search: {
          type : '',
          keyword: '',
          hq:'',
          status: ''
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          selections:[],
          pagination: this.$pagination
        },
        currDrug:{},
        currDocDrug:{},
        stockGrid:{
          loading: false,
          columns: stockColumns,
          data: []
        },
        modal:{
          visible:false,
          loading:false,
          tip:'正在加载数据....',
          drug:{},
          unitIndex:0,
          units:[],

          form: this.$form.createForm(this),
        }
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      },{
        text: "云药房",
        path: ""
      },{
        text: "出库管理",
        path: ""
      },{
        text: "药品报损",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted() {
      this.loadDrugType();
      this.searchAction();
    },
    methods: {

      loadDrugType: function () {
        let self = this;
        this.$axios.get('/api/dmz/dict/drug/types', {}).then(function (res) {
          if (res.msg.flag == 0) {
            self.init.types = res.biz;
          }
        })
      },
      buildParams:function(){
        return {
          'entity.type' : this.search.type, 'entity.keyword' : this.search.keyword, 'entity.hq':('1' == this.search.hq ? true : ('0' == this.search.hq ? false : null )), 'entity.status' : this.search.status,
        };
      },

      goback:function(){
        this.$router.go(-1)
      },


      detailAction:function(id){
        this.$router.push({ path : '/layout/pharmacy/stock/change/log?id='+id });
      },
      /**
       * 搜索按钮点击动作
       */
      searchAction:function () {
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       *  行选择事件
       */
      onSelectChange:function(selectedRowKeys){
        console.info(selectedRowKeys) ;
        for(let drug of this.grid.data||[]){
          if(drug.id == selectedRowKeys[0]){
            this.currDrug = drug;
            this.grid.selections = [drug.id]
            this.loadStockDrugs(drug.id);
          }
        }

      },

      /**
       * 查询药品
       */
      loadGrid:function(params){
        const self = this;
        self.grid.loading = true;
        self.$axios.get('/api/clinic/drug/list', {params: params}).then(function(res){
          self.grid.loading = false;
          if(res.msg.flag == 0){
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            }else{
              Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.grid.loading = false;
        });
      },

      loadStockDrugs:function(id){
        let self = this;
        Object.assign(self.stockGrid, {data: []});
        self.stockGrid.loading = true;
        self.$axios.get('/api/clinic/stockin/'+id+'/list', {}).then(function(res){
          self.stockGrid.loading = false;
          console.info(res);
          if(res.msg.flag == 0){
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.stockGrid, {data: []});
            }else{
              Object.assign(self.stockGrid, {data: res.biz});
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.stockGrid.loading = false;
        });
      },

      checkCustomRow:function (record, index){
        if(record.id == this.currDrug.id){
          return {style:{ color: 'red' }};
        }else{
          return {style:{ color: 'rgba(0, 0, 0, 0.65)' }};
        }
      },

      /**
       * 加载药品信息
       * @param id
       */
      loadDrug:function(id){
        let self = this;
        self.drug = {};
        self.modal.tip='正在加载数据....';
        self.modal.loading = true;
        this.$axios.get('/api/clinic/drug/'+id).then(function(res){
          self.modal.loading = false
          if(res.msg.flag == 0 && res.biz!=null){
            console.info(res.biz)
            self.modal.drug = res.biz;
            let units = [];
            if(null != self.modal.drug.salesUnit){
              units.push(Object.assign(self.modal.drug.salesUnit,{index:0}));
              if(!self.modal.drug.salesUnit.minUnit && self.modal.drug.minUnit!=null){
                units.push(Object.assign(self.modal.drug.minUnit,{index:1}));
              }
            }
            self.modal.unitIndex = 0;
            self.modal.units = units;


          }else{
            self.$message.error({content:'加载药品信息失败', duration:2})
          }
        },function (err) {
          self.loading = false;
          self.$message.error({content:'加载药品信息失败', duration:2})
          self.modal.visible = false;
        });
      },

      /**
       * 报损提交
       */
      submitAction:function(){
        let self = this;
        this.modal.form.validateFields((errs,values)=>{
          if(!errs){
            if(self.modal.drug == null || self.modal.drug.id == null || self.modal.drug.id == undefined){
              self.$message.error({content:'加载药品失败', duration:2});
              return;
            }
            let unit = self.modal.units[values.unitIndex];

            let params = {docDrugId:self.currDocDrug.id, drugId:self.modal.drug.id, type:'BREAKAGE_OUT', stockQty:values.stockQty, stockUnit:unit };
            self.modal.tip='正在提交药品报损数据...'
            self.modal.loading = true;
            self.$axios.post('api/clinic/stockout/stockout',params).then(function(res){
              self.modal.loading = false;
              if(res.msg.flag == 0){
                self.$message.success({content: '药品报损成功.', duration: 2});
                self.modal.form.resetFields();
                self.modal.drug = {};
                self.modal.units = [];
                self.modal.visible = false;
                self.gridChangeAction(self.grid.pagination);
                console.info(self.currDrug);
                self.loadStockDrugs(self.currDrug.id);
              }else{
                self.$message.error({content: res.msg.message, duration: 2});
              }
            }).catch(function (err) {
              self.modal.loading = false;
            });
          }
        })
      },

      closeModal:function(){
        this.modal.visible = false;
      },

      breakAction:function (id, item) {
        this.modal.visible = true;
        this.currDocDrug = item;
        this.loadDrug(id);
      }

    }
  }

  let statuses = [
    {name: 'ON_SALE', value: '已上架'},
    {name: 'OFF_SALE', value: '已下架'},
    {name: 'CANCELED', value: '已作废'},
  ];

  let columns = [
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '药品归属',
      dataIndex: 'hq',
      key: 'hq',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : (text ? '总部' : '自定义');
      },
      width: 120
    },
    {
      title: '药品类型',
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 90
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '剂型',
      dataIndex: 'form',
      key: 'drugForm',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 80
    },
    {
      title: '销售单位',
      dataIndex: 'salesUnit',
      key: 'salesUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '当前库存',
      dataIndex: 'stockQty',
      key: 'stockQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    }

  ]

  var stockColumns = [
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '采购单位',
      dataIndex: 'stockUnit',
      key: 'stockUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '采购数量',
      dataIndex: 'qty',
      key: 'qty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '当前库存',
      dataIndex: 'currQty',
      key: 'currQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 160
    },
    {
      title: '生产商',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '生产批号',
      dataIndex: 'batchNo',
      key: 'batchNo',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '有效期',
      dataIndex: 'validDate',
      key: 'validDate',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '操作',
      key: 'operate',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'operate'}
    }

  ]
</script>

<style scoped>

</style>
